/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2023 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from "../core/IceEntity";
import { IceTypes } from "../icetypes";
import { externaldatareference } from "./subs/externaldatareference";

export class encounterprogressnotes extends IceEntity {
  encounter_progress_notes_key: string = "";
  src_key: string = "";
  src_type: IceTypes.SourceType = IceTypes.SourceType.srcUndefined;
  trans_account: string = "";
  provider_trans_account: string = "";
  practice_trans_account: string = "";
  practice_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  note_date: any = NaN;
  encounter_progress_notes_type: number = 0;
  last_mentrual: any = NaN;
  prenant: boolean = false;
  estimated_dob: any = NaN;
  name: string = "";
  layout: string = "";
  cfield_data: string = "";
  plain_text: string = "";
  note_status_type;
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  EXTDATAREFS: externaldatareference[] = [];

  gettablename(): string {
    return "ENCOUNTER_PROGRESS_NOTES";
  }

  hassubtree(ColumnName): boolean {
    if (ColumnName.Length == 0) return false;
    else if (ColumnName == "EXTDATAREFS") return true;

    return false;
  }

  getsubtreetablename(ColumnName): string {
    if (ColumnName.Length == 0) return null;
    else if (ColumnName == "EXTDATAREFS") return "EXTERNAL_DATA_REFERENCE";

    return null;
  }
}
